<template>
  <div class="mb-[48px] px-[30px] text-center xl:mb-8 sm:px-0">
    <h1
      v-html="heading"
      class="text-[42px] font-semibold leading-[1.15] xl:text-[34px] md:text-[28px] md:leading-[1.25]"
      :class="[description ? 'mb-4 md:mb-3' : '']"
    ></h1>
    <div
      v-if="description"
      v-html="description"
      class="text-[18px] font-medium sm:text-[14px]"
      :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
    />
  </div>
</template>

<script>
export default {
  name: "Section",
  props: {
    heading: {
      type: String,
    },
    description: {
      type: String,
    },
    mode: String,
  },
};
</script>
